<script lang="ts">
  import { fa } from '../i18n/fa';
  import Button from './Button.svelte';
  import ErrorAlert from './ErrorAlert.svelte';

  let { error, onRetry }: { error: unknown; onRetry?: () => void } = $props();
</script>

<div class="page-enter flex flex-col items-center gap-3 py-8">
  <ErrorAlert {error} />
  {#if onRetry}
    <Button variant="secondary" onclick={onRetry}>{fa.app.retry}</Button>
  {/if}
</div>
